import Button, { ButtonProps } from "../Button";

type ToggleButtonProps = {
  isSelected: boolean;
} & ButtonProps;
export default function ToggleButton({
  children,
  isSelected,
  ...buttonProps
}: React.PropsWithChildren<ToggleButtonProps>) {
  return (
    <Button
      phantom={isSelected ? undefined : true}
      {...buttonProps}
      style={{
        ...(!isSelected && {
          outline: "1px solid rgb(195, 195, 195)",
          color: "rgb(115, 115, 115)",
        }),
        ...buttonProps.style,
      }}
    >
      {children}
    </Button>
  );
}
